export const CUSTOMER_AGENT_FEEDBACK_MESSAGE = 'CustomerAgentFeedbackMessage';